import { percentage, decimal } from '../formatters';
import zeroReducer from './zeroReducer';

const labelCallback = context => {
    const xLabel = context.parsed.x;
    const dataArr = context.dataset.data;
    const total = dataArr.reduce((acc, el) => acc + el, 0);
    const formattedLabel = total
        ? `${decimal(xLabel)} (${percentage(xLabel / total)})`
        : 0;
    return formattedLabel;
};

const decimalConfig = () => {
    return {
        scales: {
            x: {
                beginAtZero: true,
                type: 'linear',
                ticks: {
                    callback: val => {
                        return zeroReducer(val);
                    },
                },
            },
        },
        plugins: {
            tooltip: {
                callbacks: {
                    label: labelCallback,
                },
            },
        },
    };
};

export default decimalConfig;
